import { Box, BoxProps } from 'shared/mui/Box';

import { FilterBarStyled } from './FilterBar.styled';

export type FilterBarProps = { alert?: React.ReactElement } & BoxProps;

export const FilterBar: React.FC<FilterBarProps> = ({ children, alert, ...restProps }) => (
  <FilterBarStyled>
    <Box {...restProps}>{children}</Box>
    {alert}
  </FilterBarStyled>
);
